module.exports = __webpack_public_path__ + "img/0ff789a.png";